import * as React from "react";
import { observer } from "mobx-react-lite";
import { Mk8sDraftMobx } from "../../../../../mst/stores/mk8s.draft";
import { homeLink, request } from "../../../../../services/cpln";
import { ConsoleContext } from "../../../../../mobxStores/consoleContext/consoleContext";
import { DryRunAlert } from "../../../dryRunAlert";
import { mk8sDryRun } from "../../../../../mobxStores/dryRun/mk8s";
import { NGSelect } from "../../../../../newcomponents/select/ngselect";
import { NGRadioGroup } from "../../../../../newcomponents/radioGroup";
import { NGFormElement } from "../../../../../newcomponents/ngformelement/ngformelement";
import { MoreHorizontal, PlusCircle } from "react-feather";
import { useNGFormContext } from "../../../../../reactContexts/ngFormContext";
import { NGProviderBrowser } from "../../../ngProviderBrowser";
import { NGFormLabel } from "../../../../../newcomponents/text/formLabel";
import { NGKindSelect } from "../../../../../newcomponents/select/ngkindselect";
import NGAlert from "../../../../../newcomponents/alert";
import { NGProviderCreateOpaqueSecret } from "../../../ngProviderCreateOpaqueSecret";
import { getDryRunErrorText } from "../../../getDryRunErrorText";
import { NGInputListMst } from "../../../../../newcomponents/inputList/inputListMst";
import { NGInput } from "../../../../../newcomponents/input/input";
import { NGButton } from "../../../../../newcomponents/button/Button";

interface Props {
  mk8sDraft: Mk8sDraftMobx;
}
const Mk8sCreateProviderAzureRaw: React.FC<Props> = ({ mk8sDraft }) => {
  const a = mk8sDraft.provider_azure!;
  const formData = useNGFormContext();

  const [browserKey, setBrowserKey] = React.useState("");

  const [recommendedAmis, setRecommendedAmis] = React.useState([]);

  // const [azureDeployRoleArnInstructions, setAzureDeployRoleArnInstructions] = React.useState<AWSInstructions | null>(
  //   null,
  // );
  // const [azureInstructionsError, setAzureInstructionsError] = React.useState<string>("");

  React.useEffect(() => {
    fetchRecommendedAmis();
    // fetchAzureInstructions();
  }, []);

  async function fetchRecommendedAmis() {
    try {
      const { data } = await request({
        service: "api",
        url: homeLink("mk8s") + "/-discover",
        method: "post",
        body: {
          objectType: "recommendedImages",
          cluster: mk8sDraft.asObject,
        },
      });
      const res = data.data.allow.map((r: any) => ({ label: r, value: r }));
      setRecommendedAmis(res);
    } catch (e) {
      setRecommendedAmis([]);
    }
  }

  async function fetchAzureInstructions() {
    try {
      const { data } = await request({ url: `/org/${ConsoleContext.org}/mk8s/-instructions/azure` });
      // setAzureDeployRoleArnInstructions(data);
    } catch (e) {
      let errorMessage = e?.response?.data?.message;
      if (!errorMessage) errorMessage = e.message;
      // setAzureInstructionsError(errorMessage);
    }
  }

  const sshKeysDryRun = getDryRunErrorText({
    dryRunResponse: mk8sDryRun.response,
    path: `spec.provider.azure.sshKeys`,
    paths: a.sshKeys.items.map((_, idx) => `spec.provider.azure.sshKeys[${idx}]`),
  });

  return (
    <>
      <div>
        <div className="mb-4">
          <NGFormLabel required invalid={!a.sdkSecretName}>
            Azure SDK Token Secret
          </NGFormLabel>
          <div className="mb-2 flex items-start gap-2">
            <NGKindSelect
              name={"azure.sdkSecretName"}
              style={{ width: 450 }}
              value={a.sdkSecretName}
              invalid={!a.sdkSecretName}
              onChange={(value) => a.setSDKSecretName(value)}
              kind={"secret"}
              queries={[{ property: "type", value: "opaque" }]}
              buttons={[
                {
                  title: "Create",
                  render: () => <PlusCircle className="h-4" />,
                  onClick: () => setBrowserKey("createSecret"),
                },
              ]}
            />
            <DryRunAlert
              key={mk8sDryRun.key}
              canShow={formData.get("azure.sdkSecretName").touched}
              dryRunResponse={mk8sDryRun.response}
              path={"spec.provider.azure.sdkSecretLink"}
            />
          </div>
          <NGAlert
            style={{ width: 450 }}
            render={() => (
              <div className="flex flex-col text-sm">
                <span>An opaque secret that contains your Azure token.</span>
                <span>It will be used to manage servers in your Azure account.</span>
              </div>
            )}
          />
        </div>
        {/* {azureInstructionsError || !azureDeployRoleArnInstructions ? null : (
          <ProviderAWSInstructions instructions={azureDeployRoleArnInstructions} draft={mk8sDraft} />
        )} */}
        <div className="flex gap-2 items-start">
          <NGFormElement
            name={"azure.location"}
            label={a.location.label}
            value={a.location.value}
            onChange={a.location.setValue}
            required={a.location.isRequired}
            error={a.location.error}
            innerButtons={[
              {
                title: "Browse",
                onClick: () => {
                  setBrowserKey("location");
                  formData.set("azure.location", { touched: true });
                },
                render: () => <MoreHorizontal />,
              },
            ]}
          />
          <div className="mt-6">
            <DryRunAlert
              key={mk8sDryRun.key}
              canShow={formData.get("azure.location").touched}
              dryRunResponse={mk8sDryRun.response}
              onFix={a.location.setValue}
              path={"spec.provider.azure.location"}
            />
          </div>
        </div>
        <div className="flex gap-2 items-start">
          <NGFormElement
            name={"azure.subscriptionId"}
            label={a.subscriptionId.label}
            value={a.subscriptionId.value}
            onChange={a.subscriptionId.setValue}
            required={a.subscriptionId.isRequired}
            error={a.subscriptionId.error}
            innerButtons={[
              {
                title: "Browse",
                onClick: () => {
                  setBrowserKey("subscriptions");
                  formData.set("azure.subscriptionId", { touched: true });
                },
                render: () => <MoreHorizontal />,
              },
            ]}
          />
          <div className="mt-6">
            <DryRunAlert
              key={mk8sDryRun.key}
              canShow={formData.get("azure.subscriptionId").touched}
              dryRunResponse={mk8sDryRun.response}
              onFix={a.subscriptionId.setValue}
              path={"spec.provider.azure.subscriptionId"}
            />
          </div>
        </div>
        <div className="flex gap-2 items-start">
          <NGFormElement
            name={"azure.resourceGroup"}
            label={a.resourceGroup.label}
            value={a.resourceGroup.value}
            onChange={a.resourceGroup.setValue}
            required={a.resourceGroup.isRequired}
            error={a.resourceGroup.error}
            innerButtons={[
              {
                title: "Browse",
                onClick: () => {
                  setBrowserKey("resourceGroups");
                  formData.set("azure.resourceGroup", { touched: true });
                },
                render: () => <MoreHorizontal />,
              },
            ]}
          />
          <div className="mt-6">
            <DryRunAlert
              key={mk8sDryRun.key}
              canShow={formData.get("azure.resourceGroup").touched}
              dryRunResponse={mk8sDryRun.response}
              onFix={a.resourceGroup.setValue}
              path={"spec.provider.azure.resourceGroup"}
            />
          </div>
        </div>
        <div className="flex gap-2 items-start">
          <NGFormElement
            name={"azure.networkId"}
            label={a.networkId.label}
            value={a.networkId.value}
            onChange={a.networkId.setValue}
            required={a.networkId.isRequired}
            error={a.networkId.error}
            innerButtons={[
              {
                title: "Browse",
                onClick: () => {
                  setBrowserKey("networks");
                  formData.set("azure.networkId", { touched: true });
                },
                render: () => <MoreHorizontal />,
              },
            ]}
          />
          <div className="mt-6">
            <DryRunAlert
              key={mk8sDryRun.key}
              canShow={formData.get("azure.networkId").touched}
              dryRunResponse={mk8sDryRun.response}
              onFix={a.networkId.setValue}
              path={"spec.provider.azure.networkId"}
            />
          </div>
        </div>
        <NGInputListMst
          data={a.sshKeys}
          className="mb-8"
          styles={{ container: { width: 900 } }}
          label="SSH Keys"
          firstLabel="Key"
          firstInput={(i, index) => {
            let invalid = false;
            if (sshKeysDryRun.message.split("[")[1]?.split("]")[0] === String(index)) {
              invalid = true;
            }

            return <NGInput invalid={invalid} value={i.firstValue} onChange={(e) => i.setFirstValue(e.target.value)} />;
          }}
          invalid={sshKeysDryRun.severity === "error"}
          error={sshKeysDryRun.severity === "error" ? sshKeysDryRun.message : ""}
          warning={sshKeysDryRun.severity === "error" ? "" : sshKeysDryRun.message}
        />
        <div className="my-4 p-4 border rounded w-min gap-2" style={{ minWidth: 450 }}>
          <NGFormLabel
            name={a.image.type === "recommended" ? "azure.image.recommended" : "azure.image.reference"}
            required
            invalid={
              a.image.type === "recommended"
                ? !a.image.recommended
                : a.image.type === "reference"
                ? !a.image.reference_publisher.value ||
                  !a.image.reference_offer.isValid ||
                  !a.image.reference_sku.isValid ||
                  !a.image.reference_version.isValid
                : true
            }
          >
            Image
          </NGFormLabel>
          <NGRadioGroup
            className="mb-2"
            options={[
              { label: "Recommended", value: "recommended" },
              { label: "Reference", value: "reference" },
            ]}
            value={a.image.type}
            onChange={(value) => a.image.setType(value as any)}
          />
          {a.image.type === "recommended" ? (
            <NGSelect
              name={`azure.image.recommended`}
              value={a.image.recommended}
              invalid={!a.image.recommended}
              onChange={a.image.setRecommended}
              options={recommendedAmis}
            />
          ) : a.image.type === "reference" ? (
            <div>
              <NGFormElement
                name={"azure.image.reference.publisher"}
                label={a.image.reference_publisher.label}
                value={a.image.reference_publisher.value}
                onChange={a.image.reference_publisher.setValue}
                required={a.image.reference_publisher.isRequired}
                error={a.image.reference_publisher.error}
              />
              <NGFormElement
                name={"azure.image.reference.offer"}
                label={a.image.reference_offer.label}
                value={a.image.reference_offer.value}
                onChange={a.image.reference_offer.setValue}
                required={a.image.reference_offer.isRequired}
                error={a.image.reference_offer.error}
              />
              <NGFormElement
                name={"azure.image.reference.sku"}
                label={a.image.reference_sku.label}
                value={a.image.reference_sku.value}
                onChange={a.image.reference_sku.setValue}
                required={a.image.reference_sku.isRequired}
                error={a.image.reference_sku.error}
              />
              <NGFormElement
                name={"azure.image.reference.version"}
                label={a.image.reference_version.label}
                value={a.image.reference_version.value}
                onChange={a.image.reference_version.setValue}
                required={a.image.reference_version.isRequired}
                error={a.image.reference_version.error}
              />
            </div>
          ) : null}

          <DryRunAlert
            key={mk8sDryRun.key}
            canShow={
              formData.get("azure.image.recommended").touched ||
              formData.get("azure.image.reference.publisher").touched ||
              formData.get("azure.image.reference.offer").touched ||
              formData.get("azure.image.reference.sku").touched ||
              formData.get("azure.image.reference.version").touched
            }
            dryRunResponse={mk8sDryRun.response}
            path={`spec.provider.azure.image`}
            paths={[
              `spec.provider.azure.image.recommended`,
              `spec.provider.azure.image.reference`,
              `spec.provider.azure.image.reference.publisher`,
              `spec.provider.azure.image.reference.offer`,
              `spec.provider.azure.image.reference.sku`,
              `spec.provider.azure.image.reference.version`,
            ]}
          />
        </div>
      </div>
      {browserKey === "createSecret" ? (
        <NGProviderCreateOpaqueSecret
          onOk={(secretName: string) => a.setSDKSecretName(secretName)}
          onClose={() => setBrowserKey("")}
          title={"Create Opaque Secret"}
          dataLabel={"Azure SDK Token"}
        />
      ) : null}
      {browserKey === "location" ? (
        <NGProviderBrowser
          title="Browse Azure Locations"
          initialValue={a.location.value}
          fetchData={async () => {
            const { data } = await request({
              service: "api",
              url: homeLink("mk8s") + "/-discover",
              method: "post",
              body: {
                objectType: "locations",
                cluster: mk8sDraft.asObject,
              },
            });
            return data;
          }}
          onOk={(value) => a.location.setValue(value as string)}
          onClose={() => setBrowserKey("")}
          labels={["Name", "Value"]}
          getData={(item: any) => [item.location, item.displayName, item.location]}
        />
      ) : null}
      {browserKey === "resourceGroups" ? (
        <NGProviderBrowser
          title="Browse Azure Resource Groups"
          initialValue={a.resourceGroup.value}
          fetchData={async () => {
            const { data } = await request({
              service: "api",
              url: homeLink("mk8s") + "/-discover",
              method: "post",
              body: {
                objectType: "resourceGroups",
                cluster: mk8sDraft.asObject,
              },
            });
            return data;
          }}
          onOk={(value) => a.resourceGroup.setValue(value as string)}
          onClose={() => setBrowserKey("")}
          labels={["Name", "Id"]}
          getData={(item: any) => [item.name, item.name, item.id]}
        />
      ) : null}
      {browserKey === "networks" ? (
        <NGProviderBrowser
          title="Browse Azure Networks"
          initialValue={a.networkId.value}
          fetchData={async () => {
            const { data } = await request({
              service: "api",
              url: homeLink("mk8s") + "/-discover",
              method: "post",
              body: {
                objectType: "networks",
                cluster: mk8sDraft.asObject,
              },
            });
            return data;
          }}
          onOk={(value) => a.networkId.setValue(value as string)}
          onClose={() => setBrowserKey("")}
          labels={["Name", "Id", "Resource Group"]}
          getData={(item: any) => [item.id, item.name, item.id, item.resourceGroup]}
        />
      ) : null}
      {browserKey === "subscriptions" ? (
        <NGProviderBrowser
          title="Browse Azure Subscriptions"
          initialValue={a.subscriptionId.value}
          fetchData={async () => {
            const { data } = await request({
              service: "api",
              url: homeLink("mk8s") + "/-discover",
              method: "post",
              body: {
                objectType: "subscriptions",
                cluster: mk8sDraft.asObject,
              },
            });
            return data;
          }}
          onOk={(value) => a.subscriptionId.setValue(value as string)}
          onClose={() => setBrowserKey("")}
          labels={["Name", "Id"]}
          getData={(item: any) => [item.id, item.displayName, item.id]}
        />
      ) : null}
    </>
  );
};

export const Mk8sCreateProviderAzure = observer(Mk8sCreateProviderAzureRaw);
